import env from '@shared/api/env';

export type FlowRow = {
  id: string;
  name: string;
  description?: string | null;
  revision: number;
  updated_at: string;
  graph: { nodes: any[]; edges: any[] } | null;
};

const base = env.PGR_BASE.replace(/\/$/, '');
const json = (r: Response) => r.json();
const asQuery = (obj: Record<string, string>) =>
  Object.entries(obj)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');

export async function listFlows(headers?: HeadersInit): Promise<FlowRow[]> {
  const url = `${base}/flows?${asQuery({ select: 'id,name,description,revision,updated_at', order: 'name.asc' })}`;
  const r = await fetch(url, { headers: { Accept: 'application/json', ...(headers ?? {}) } });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return json(r);
}

export async function getFlow(id: string, headers?: HeadersInit): Promise<FlowRow | null> {
  const url = `${base}/flows?${asQuery({ ['id']: `eq.${id}`, select: 'id,name,description,revision,graph,updated_at' })}`;
  const r = await fetch(url, { headers: { Accept: 'application/json', ...(headers ?? {}) } });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const arr = await json(r);
  return Array.isArray(arr) && arr.length ? arr[0] : null;
}

export async function createFlow(doc: Partial<FlowRow>, headers?: HeadersInit): Promise<FlowRow> {
  const r = await fetch(`${base}/flows`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Prefer: 'return=representation', ...(headers ?? {}) },
    body: JSON.stringify(doc),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const arr = await json(r);
  return arr[0];
}

export async function updateFlow(id: string, patch: Partial<FlowRow>, revision: number, headers?: HeadersInit): Promise<FlowRow | null> {
  const url = `${base}/flows?${asQuery({ id: `eq.${id}`, revision: `eq.${revision}` })}`;
  const r = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Prefer: 'return=representation', ...(headers ?? {}) },
    body: JSON.stringify(patch),
  });
  if (!r.ok && r.status !== 409 && r.status !== 412) throw new Error(`HTTP ${r.status}`);
  const arr = await json(r);
  return Array.isArray(arr) && arr.length ? arr[0] : null;
}

export async function forceUpdateFlow(id: string, patch: Partial<FlowRow>, headers?: HeadersInit): Promise<FlowRow> {
  const url = `${base}/flows?${asQuery({ id: `eq.${id}` })}`;
  const r = await fetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Prefer: 'return=representation', ...(headers ?? {}) },
    body: JSON.stringify(patch),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const arr = await json(r);
  return arr[0];
}
